import {
  postEmergencyContact,
  putDSDetails,
  putEmergencyContact,
  searchEmergencyContacts,
} from "../services/emergencyPlanning.service";
import { filterUnique, updateRecord } from "../utils/filter";
import { NotificationToaster } from "../utils/notificationToaster";
import { numberUnMasking } from "../utils/string";

const addEmergencyContactAction = (data) => (dispatch) => {
  data.phone = numberUnMasking(data.phone);
  return postEmergencyContact(data)
    .then((contactResponse) => {
      const contact = contactResponse.data;
      dispatch(selectEmergencyContact(contact));
      return Promise.resolve(contact);
    })
    .catch((err) => {
      dispatch({ type: "POST_EMERGENCY_CONTACT_ERROR", payload: err.message });
      NotificationToaster({
        message: "Phone number already exists",
        type: "warning",
      });
      return Promise.reject();
    });
};

const updateEmergencyContactAction = (data) => (dispatch, getState) => {
  data.phone = numberUnMasking(data.phone);
  const emergencyContacts = getState().wizard.emergencyPlan.contacts;
  return putEmergencyContact(data)
    .then((contactResponse) => {
      const updatedEmergencyContacts = updateRecord(
        emergencyContacts,
        data,
        "emergencyContactID",
      );
      dispatch({
        type: `UPDATE_EMERGENCY_CONTACTS`,
        payload: updatedEmergencyContacts,
      });
      return Promise.resolve(contactResponse);
    })
    .catch((err) => {
      dispatch({ type: "PUT_EMERGENCY_CONTACT_ERROR", payload: err.message });
      NotificationToaster({
        message: "Phone number already exists",
        type: "warning",
      });
      return Promise.reject();
    });
};

const updateDSDetails = (clientId, data) => (dispatch, getState) => {
  const { emergencyPlan } = getState().wizard;

  data.disasterDetails = !!data.disasterDetails ? data.disasterDetails : "";
  const payload = {
    userID: clientId,
    disasterDetails: data.disasterDetails,
  };

  if (emergencyPlan?.disasterDetails !== payload?.disasterDetails) {
    return putDSDetails(payload)
      .then(() => {
        dispatch({
          type: "UPDATE_DISASTER_EMERGENCY_PLAN",
          payload: data.disasterDetails,
        });
        return Promise.resolve();
      })
      .catch((err) => {
        dispatch({
          type: "UPDATE_DISASTER_EMERGENCY_PLAN_ERROR",
          payload: err.message,
        });
        NotificationToaster({ message: "Something went wrong", type: "error" });
      });
  } else {
    return Promise.resolve();
  }
};

const searchEmergencyContactsAction = (searchParams) => (dispatch) => {
  return searchEmergencyContacts(searchParams)
    .then((contactsResponse) => {
      const contacts = contactsResponse.data;
      return Promise.resolve(contacts);
    })
    .catch((err) => {
      dispatch({
        type: "SEARCH_EMERGENCY_CONTACTS_ERROR",
        payload: err.message,
      });
      NotificationToaster({ message: "Something went wrong", type: "error" });
    });
};

const selectEmergencyContact = (row) => (dispatch, getState) => {
  const { wizard } = getState();
  dispatch({
    type: `UPDATE_EMERGENCY_CONTACTS`,
    payload: filterUnique(
      wizard.emergencyPlan.contacts,
      row,
      "emergencyContactID",
    ),
  });
  return Promise.resolve();
};

const unSelectEmergencyContact = (row) => async (dispatch, getState) => {
  const { wizard } = getState();
  dispatch({
    type: `UPDATE_EMERGENCY_CONTACTS`,
    payload: wizard.emergencyPlan.contacts.filter(
      (item) => item.emergencyContactID !== parseInt(row.emergencyContactID),
    ),
  });
  return Promise.resolve();
};

export {
  addEmergencyContactAction,
  updateEmergencyContactAction,
  updateDSDetails,
  searchEmergencyContactsAction,
  selectEmergencyContact,
  unSelectEmergencyContact,
};
